import {
	SET_CURRENT_TAB,
	CONTENT_SET,
	CONTENT_LOADING,
	CONTENT_ERROR,
	USER_INIT,
	UPDATE_USER_AVATAR,
	ENABLE_TAB_CACHING,
	DISABLE_TAB_CACHING,
	UPDATE_CURRENT_TAB_URL,
} from 'constants/actions';

import commonService from 'services/CommonService';
import settingsService, { SORT_POSTFIX } from 'services/settingsService';
import * as api from 'api';
import { generateRandomAvatarPayload } from 'services/avatarAutoGenerate';
import reporter from '../monitoring/errorReporter';

export const initUser = data => ({
	type: USER_INIT,
	info: data,
});

export const getUserInfo = () => dispatch => {
	dispatch(api.mw.auth.auth.initiate())
		.unwrap()
		.then(async response => {
			if (response?.success && response?.result) {
				const userId = response.result.user?.id;
				const hasAvatar = Boolean(response.result.avatar);
				const sessionKey = userId ? `auto_avatar_${userId}` : null;

				dispatch(initUser({
					...response.result.user,
					user_photo: response.result.avatar,
					userPhones: response.result.userPhones,
					operations: response.result.operations || [],
					matrixToken: response.result.matrixToken,
					matrixUserId: response.result.matrixUserId,
					matrixBaseUrl: response.result.matrixBaseUrl,
					matrixDeviceId: response.result.matrixDeviceId,
					appealWorkspaceV2: response.result.featureFlags?.appealWorkspaceV2 ?? null,
				}));

				// Enrich frontend error logs with minimal user context (no PII like phones/tokens).
				try {
					const u = response.result.user || {};
					reporter.setUser({
						id: u.id,
						domain: u.domain,
						role: u.user_role,
						admin: Boolean(u.admin),
					});
					if (u.domain) {
						reporter.addLabels({ domain: u.domain });
					}
				} catch (e) {}

				sessionStorage.setItem('matrixAuth', JSON.stringify({
					matrixToken: response.result.matrixToken,
					matrixUserId: response.result.matrixUserId,
					matrixBaseUrl: response.result.matrixBaseUrl,
					matrixDeviceId: response.result.matrixDeviceId,
				}));

				if (!hasAvatar && userId && sessionKey && !sessionStorage.getItem(sessionKey)) {
					sessionStorage.setItem(sessionKey, '1');
					try {
						const payload = await generateRandomAvatarPayload();
						const saveResponse = await dispatch(api.mw.personalCabinet.saveAvatar.initiate(payload)).unwrap();
						const savePayload = saveResponse?.data ?? saveResponse;
						if (savePayload?.success === false) {
							throw new Error(savePayload?.errorMessageText || savePayload?.errorMessage || 'Failed to save avatar');
						}

						const result = savePayload?.result || {};
						if (result.avatarUrl) {
							const updatedAt = result.avatarUpdatedAt || Date.now();
							dispatch(updateUserAvatar(`${result.avatarUrl}?v=${updatedAt}`));
						}
					} catch (error) {
						console.error(`autoAvatar: ${error?.message || error}`);
					}
				}
			}
		})
		.catch(error => {
			if (error?.name === 'AbortError') {
				return;
			}

			console.error(`getUserInfo: ${error?.message || error}`);
		});
};

export const setUserInfo = data => {
	// const params = {
	// 	path: 'lang',
	// 	data: { lang: data.lang_default },
	// };

	// baseService.post('user_settings', params);

	return {
		type: USER_INIT,
		info: data,
	};
};

export const updateUserAvatar = user_photo => ({
	type: UPDATE_USER_AVATAR,
	payload: { user_photo },
});

export const enableTabCaching = () => ({
	type: ENABLE_TAB_CACHING,
});

export const disableTabCaching = () => ({
	type: DISABLE_TAB_CACHING,
});

export function setCurrentTab(data) {
	return (dispatch) => {
		dispatch({
			type: SET_CURRENT_TAB,
			...data,
		});
	};
}

export const updateCurrentTabUrl = currentUrl => ({
	type: UPDATE_CURRENT_TAB_URL,
	currentUrl,
});

const contentLoading = (storeName) => ({
	type: CONTENT_LOADING,
	storeName,
});

const contentError = (data) => ({
	type: CONTENT_ERROR,
	...data,
});

export const initProxy = (api, options, url) => (dispatch) => {
	if (!api.key) {
		return null;
	}

	const isPost = api.method && api.method.toLowerCase() === 'post';
	const storeName = options.storeName(options.params);
	const queryKey = options.queryKey && options.queryKey(options.params);

	// Load sort settings.
	const cachedSortSettings = settingsService.get(`${queryKey}${SORT_POSTFIX}`);
	const apiData = { ...api };

	if (apiData.data.limit) {
		apiData.data = {
			...apiData.data,
			page: apiData.data.page || 1,
			start: apiData.data.start || 0,
		};
	}

	if (cachedSortSettings) {
		apiData.data = {
			...apiData.data,
			sort: cachedSortSettings,
		};
	}

	dispatch(contentLoading());

	commonService.initProxy(api.key, apiData, isPost)
		.then(data => {
			data = data?.response?.data || data;

			const dispatchData = {
				type: CONTENT_SET,
				url,
				api: apiData,
			};

			// debugger
			dispatchData.query = {
				...apiData.data,
				total: data && data.total,
			};

			// this hack need to save filter state after CONTENT_UPDATE
			if (dispatchData.query.filter && dispatchData.query.filter.length) {
				delete dispatchData.query.filter;
			}

			// mainTab name (tabs reducer)
			if (options.name) {
				dispatchData.name = options.name({
					...(data && data.result),
					...options.params,
					api,
				});
			}

			// mainTab type (unique tab) (tabs reducer)
			if (options.tabType) {
				dispatchData.tabType = options.tabType(options.params);
			}

			// key for determination of request data
			if (queryKey) {
				dispatchData.queryKey = queryKey;
			}

			dispatchData.storeName = storeName;

			if (data && typeof data === 'object') {
				data.tabName = storeName;
			}

			dispatchData.data = data;

			// debugger;
			dispatch(dispatchData);
		})
		.catch(error => {
			// If aborted.
			if (error.name === 'AbortError') {
				return;
			}

			// If wrong.
			dispatch(contentError({
				error,
				storeName,
			}));

			console.error(`initProxy: ${error.message}`);
		});
};
